import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/graded-card-prices")({
  component: Outlet,
});
